export default [
  {
    title: 'مدیریت تیکت ها',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'تیکت ها',
        route: { name: 'ticket' },
        resource: 'TicketManager',
        action: 'show',
      },
      {
        title: 'دپارتمان ها',
        route: { name: 'ticketcategory' },
        resource: 'TicketCategoryManager',
        action: 'show',
      },
    ],
  },
]
